/* eslint-disable array-callback-return */
/* eslint-disable indent */
import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { AWS_KEYS } from "../../../apis/api";
import { helperFunction } from "../../../constant/helper";
import AddComments from "./AddComments";
import QueryBody from "./QueryBody";
import QueryComments from "./QueryComments";
import Starter from "../../../component/Starter";
import {
  addQueryComment,
  clearQueryErrors,
  clearQueryResult,
  setQueryLoading,
  getQueryDetails,
  setCommentLoading
} from "../../../redux/actions/queryActions";
import isEmpty from "../../../validation/isEmpty";
import Card from "../../../component/card/Card";
import AWS from "aws-sdk";

const initialCommentState = {
  commentBody: "",
  commentStatus: "",
  querySolveDate: ""
};

AWS.config.update({
  accessKeyId: AWS_KEYS.accessKeyId,
  secretAccessKey: AWS_KEYS.secretAccessKey
});

const myBucket = new AWS.S3({
  params: { Bucket: AWS_KEYS.s3Bucket },
  region: AWS_KEYS.s3Region
});

const QueryDetails = () => {
  const dispatch = useDispatch();
  const { query_id } = useParams();
  const loginType = localStorage.loginType;

  const [commentScreenshots, setCommentScreenshots] = useState([]);
  const [selectedEmail, setSelectedEmail] = useState([]);
  const [
    commentScreenshotsLoading,
    setCommentScreenshotsLoading
  ] = useState(false);
  const [queryDetailsObject, setQueryDetailsObject] = useState({});
  const [commentInput, setCommentInput] = useState(
    initialCommentState
  );

  const {
    queryLoading,
    queryDetails,
    queryError,
    queryResponse,
    commentLoading
  } = useSelector((state) => state.query);

  useEffect(() => {
    if (queryError) {
      helperFunction.toastHelper("error", queryError);
    }
    if (queryResponse) {
      helperFunction.toastHelper("success", queryResponse);
    }
  }, [queryError, queryResponse]);

  useEffect(() => {
    if (queryDetails !== null) {
      setQueryDetailsObject(queryDetails);
    } else {
      setQueryDetailsObject({});
    }
  }, [queryDetails]);

  useEffect(() => {
    dispatch(setQueryLoading(true));
    dispatch(setCommentLoading(false));
    dispatch(clearQueryErrors());
    dispatch(clearQueryResult());
    dispatch(getQueryDetails(query_id, loginType));
    return () => {
      dispatch(setQueryLoading(false));
      dispatch(setCommentLoading(false));
      dispatch(clearQueryErrors());
      dispatch(clearQueryResult());
    };
  }, [query_id]);

  const handleInitialState = (e) => {
    const { name, value } = e.target;
    setCommentInput({
      ...commentInput,
      [name]: value
    });
  };

  const getCommentImagesUrl = async (e) => {
    const { files } = e.target;
    const file = files[0];
    const totalSizeMB = files[0].size / Math.pow(1024, 2);

    if (parseFloat(totalSizeMB).toFixed(2) <= 2) {
      const params = {
        Body: file,
        Bucket: AWS_KEYS.s3Bucket,
        Key: file.name
      };

      const uploaded = await myBucket.upload(params).promise();
      const { Location } = uploaded;

      if (Location) {
        setCommentScreenshots((previous) => [...previous, Location]);

        setCommentScreenshotsLoading(false);
      } else {
        setCommentScreenshotsLoading(false);
        helperFunction.toastHelper(
          "error",
          "Error While uploading file"
        );
      }
    } else {
      setCommentScreenshotsLoading(false);
      helperFunction.toastHelper(
        "error",
        "File size is more than 2MB"
      );
    }
  };

  const onEmailChangesHandle = (input) => {
    setSelectedEmail(input);
  };

  const handleResponseSubmit = (e) => {
    e.preventDefault();
    const sendCommentToEmails = [];
    selectedEmail.map((mail) => {
      sendCommentToEmails.push(mail.value);
    });
    const commentData = {
      queryId: query_id,
      commentScreenshots,
      sendCommentToEmails,
      commentBody: commentInput.commentBody,
      commentStatus: commentInput.commentStatus,
      querySolveDate: commentInput.querySolveDate
    };

    dispatch(setCommentLoading(true));
    dispatch(clearQueryErrors());
    dispatch(clearQueryResult());
    dispatch(addQueryComment(commentData, loginType));
  };
  return (
    <Starter
      topBarTitle="Query Details"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Query Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Query</a>
          </li>
          <li className="breadcrumb-item active">Query Detail</li>
        </Fragment>
      }
    >
      {!isEmpty(queryDetailsObject) && (
        <QueryBody
          queryDetailsObject={queryDetailsObject}
          queryLoading={queryLoading}
        />
      )}

      <div className="row ">
        <div
          className="col-xl-7 col-lg-7 col-md-7 col-sm-12"
          style={{
            height: "700px",
            overflow: "auto"
          }}
        >
          <QueryComments
            queryComments={queryDetailsObject?.queryComments || []}
            commentLoading={commentLoading}
          />
        </div>
        <div className="col-xl-5 col-lg-5 col-md-5 col-sm-12">
          <Card>
            <AddComments
              commentInput={commentInput}
              selectedEmail={selectedEmail}
              commentLoading={commentLoading}
              handleInitialState={handleInitialState}
              commentScreenshots={commentScreenshots}
              getCommentImagesUrl={getCommentImagesUrl}
              onEmailChangesHandle={onEmailChangesHandle}
              handleResponseSubmit={handleResponseSubmit}
              commentScreenshotsLoading={commentScreenshotsLoading}
            />
          </Card>
        </div>
      </div>
    </Starter>
  );
};

export default QueryDetails;
